import CityList from './CityList'
import CityCreate from './CityCreate'
import CityEdit from './CityEdit'

export default { list: CityList, create: CityCreate, edit: CityEdit }
